// hooks/useReducedMotion.js
// true when the person has asked their OS/browser for less motion. Decorative
// animation (confetti, particle backgrounds) must not run then; state changes
// still show, just without the travel (tokens.css collapses transitions).
import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

export default function useReducedMotion() {
    const get = () => typeof window !== "undefined" && !!window.matchMedia?.(QUERY).matches;
    const [reduced, setReduced] = useState(get);
    useEffect(() => {
        const mq = window.matchMedia?.(QUERY);
        if (!mq) return undefined;
        const on = () => setReduced(mq.matches);
        mq.addEventListener?.("change", on);
        return () => mq.removeEventListener?.("change", on);
    }, []);
    return reduced;
}
